import { APPLICATION_STATUS_TYPE } from '../../../utils/statusConstants/statusConstants';

export const departmentFullListFilter = (): any => {
  return {
    status: {
      nin: [
        APPLICATION_STATUS_TYPE.CREATED,
        APPLICATION_STATUS_TYPE.APPLICATION_FEE_PENDING,
      ],
    },
  };
};

export const facultyFullListFilter = (): any => {
  return {
    status: {
      nin: [
        APPLICATION_STATUS_TYPE.CREATED,
        APPLICATION_STATUS_TYPE.APPLICATION_FEE_PENDING,
      ],
    },
  };
};
